import { FC } from 'react';
import { StatusType } from '../../sp-types/statusType';
import { StatusBox } from './status/StatusBox';

export interface FormHeadingProps {
  id?: string;
  title?: string;
  description?: string;
  status?: StatusType;
}
export const FormHeading: FC<FormHeadingProps> = ({ description, id, title, status }) => {
  return (
    <div className="flex justify-between">
      <div className="flex space-x-[0.5rem] ">
        {id && <div className="text-red text-xl font-semibold ">{id}</div>}
        <div className="flex flex-col space-y-[0.5rem]">
          {title && <div className="text-xl">{title}</div>}
          {description && (
            <div className="text-sm text-secondary_text font-medium sm:hidden md:block ">{description}</div>
          )}
        </div>
      </div>
      <div>{status && <StatusBox status={status} />}</div>
    </div>
  );
};
